function HomeController(){
	this.className			= "HomeController";
	this.view				= false; //"example";
	this.glob				= ["/", "/?*", "/home*"];
    this.viewData			= {};
    this.log                = false;
    

}

HomeController.inheritsFrom( PageController );
HomeController.prototype.setup = function(onComplete){
	if(this.isSetup) return;

	this.$body				= $('body');

	this.baseController = Aviator.get("baseController")

	this.isSetup = true;
}
HomeController.prototype.swap = function(onComplete){
    if(!this.isSetup) this.setup();

	this.animationGroups = [];

	this.imageController = this.baseController.getImageController();
	this.configLettersAnimation();

    this.imageLoadedOrFailedDelegate =  (e) => {
        if(!e.image) return; //Early ones aren't ready with an image

        const $container = e.image.$wrapper;
        const index = $container.attr("data-index") * 1;
        this.updateLettersAnimation(index);

        //Check all the images have loaded before showing anything...
        if(e.target.images.every(i => i.loaded || i.status == "failed")){
            onComplete();
        }

    };

	this.imageController.addListener("refresh",this.imageLoadedOrFailedDelegate);
    this.imageController.addListener("failed",this.imageLoadedOrFailedDelegate);

    return false;

}
HomeController.prototype.on = function(onComplete){
    if (this.log) console.log(`%c[homeController]`, 'background:lightgreen', `on`);

    return true;    
}

HomeController.prototype.configLettersAnimation = function() {

    if (this.log) console.log(`%c[homeController]`, 'background:lightgreen', `configLettersAnimation`);

    const containersSelector = '.concept-image-container';
    const lettersSelector = '.concept-letter';

    const containers = document.querySelectorAll(containersSelector);
    containers.forEach(container => {
        const containerSelector = `#${container.id} .img-replace`;

        const letters = container.querySelectorAll(lettersSelector);
        const lettersArrayToAnimate = [];
        letters.forEach((letter) => {
            lettersArrayToAnimate.push({
                selector: `#${letter.id}`,                
                start: {
                    x: parseFloat(letter.dataset['startX']),
                    y: parseFloat(letter.dataset['startY'])
                },
                end: {
                    x: parseFloat(letter.dataset['endX']),
                    y: parseFloat(letter.dataset['endY'])
                },
                duration: parseFloat(letter.dataset['duration']),                
                delay: parseFloat(letter.dataset['delay']),
                ease: letter.dataset['ease'],
            });
        })

        const animationGroup = new AnimationController({
            containerSelector,
            items: lettersArrayToAnimate,
            triggerStart: container.dataset['triggerStart'],
            triggerEnd: container.dataset['triggerEnd'],
            showMarkers: container.dataset['showMarkers']
        });

        this.animationGroups.push(animationGroup);

    });

}
HomeController.prototype.updateLettersAnimation = function(imageIndex) {
    this.animationGroups[imageIndex].calculateContainerBaseDimensions();
}
HomeController.prototype.off = function(onComplete){
    this.imageController.removeListener("refresh",this.imageLoadedDelegate);
}